import React from 'react';
import PropTypes from 'prop-types';
import { SpeakerIcon } from 'taboola-ultimate-ui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import SectionHeader from '../../../../components/Form/SectionHeader/SectionHeader';
import { ENTITY_MESSAGE_PREFIX } from '../../../../config/routes';
import AccountDropdown from '../AccountDropdown';

const SetupSection = ({ isAccountSelectionEnabled, children, accountFilter, messageIdPrefix, noAccountsMessageId }) => {
    const { formAccount, setFormAccount } = useFormDataContext();

    return (
        <CommonCollapsibleCard
            id="CAMPAIGN_SETUP"
            header={
                <SectionHeader
                    headerIcon={<SpeakerIcon />}
                    headerText={
                        <FormattedMessage id={`${messageIdPrefix}.editor.setup`} defaultMessage="Campaign Setup" />
                    }
                />
            }
        >
            {isAccountSelectionEnabled && (
                <AccountDropdown
                    accountForCampaign={formAccount}
                    onAccountChange={setFormAccount}
                    helpText={
                        <FormattedMessage
                            id="campaign.account.help"
                            defaultMessage="The new campaign will be created in the selected account."
                        />
                    }
                    accountFilter={accountFilter}
                    noAccountsMessageId={noAccountsMessageId}
                />
            )}
            {children}
        </CommonCollapsibleCard>
    );
};

SetupSection.propTypes = {
    isAccountSelectionEnabled: PropTypes.bool,
    children: PropTypes.node,
    accountFilter: PropTypes.func,
    messageIdPrefix: PropTypes.string,
    noAccountsMessageId: PropTypes.string,
};

SetupSection.defaultProps = { messageIdPrefix: ENTITY_MESSAGE_PREFIX.CAMPAIGN };

export default SetupSection;
